import { Box, Button } from "@mui/material";
import { useState } from "react";
import FilterSubmenu from "../../scenes/settings/inbox/FilterSubmenu";
import { getToolIcon } from "../../scenes/settings/inbox/utils/notificationUtils";
const mockTools = ["slack", "zoom", "google-drive"];
const mockColors = {
  grey_48percent: "rgba(0,0,0,0.48)",
  text_secondary: "#888",
  text_primary: "#222",
};

const getIcon = (tool) => getToolIcon(tool);
const getDisplayName = (tool) => `Display for ${tool}`;

const FilterSubmenuDemo = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState([]);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleToggle = (item) => {
    setSelected((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  return (
    <Box>
      <Button variant="outlined" onClick={handleOpen}>
        Open menu
      </Button>
      <FilterSubmenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        title="Select Tools"
        items={mockTools}
        selectedItems={selected}
        onItemToggle={handleToggle}
        getIcon={getIcon}
        getDisplayName={getDisplayName}
        colors={mockColors}
      />
    </Box>
  );
};

export default FilterSubmenuDemo;
